import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FloatingModal } from '../../../components/Modal';
import Input from '../../../../Account/components/Input';
import styles from './security.scss';

const propTypes = {
  show: PropTypes.bool,
  errors: PropTypes.shape(),

  onVerifyClick: PropTypes.func,
  onModalClose: PropTypes.func,
};

class CreateYubikey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
    };
  }

  render() {
    const {
      show, errors,
    } = this.props;
    const {
      name, code,
    } = this.state;

    return (
      <FloatingModal
        isOpen={show}
        onRequestClose={() => this.props.onModalClose()}
        action={{
          onClick: () => this.props.onVerifyClick({ type: 'yubikey', code, name }, true),
          text: 'Add',
        }}
        buttonText="Cancel"
      >
        <div className={styles.modal}>
          <div className={styles.modalTitle}>Add a yubikey</div>
          <div className={styles.modalMessage}>
            The YubiKey is a hardware authentication device manufactured by Yubico that
            supports one-time passwords.
          </div>
          <Input
            label={(
              <>
                Name
                {' '}
                <small>(something so you can identify your key later)</small>
              </>
)}
            id="name"
            type="text"
            onChange={(event) => this.setState({ name: event.target.value })}
            value={name}
            errors={errors}
          />
          <Input
            label="YubiKey OTP"
            id="code"
            type="text"
            onChange={(event) => this.setState({ code: event.target.value })}
            value={code}
            errors={errors}
          />
        </div>
      </FloatingModal>
    );
  }
}

CreateYubikey.propTypes = propTypes;

export default CreateYubikey;
